import { render, staticRenderFns } from "./banshu-dialog.vue?vue&type=template&id=71757cb6&scoped=true"
import script from "./banshu-dialog.vue?vue&type=script&lang=ts"
export * from "./banshu-dialog.vue?vue&type=script&lang=ts"
import style0 from "./banshu-dialog.vue?vue&type=style&index=0&id=71757cb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71757cb6",
  null
  
)

export default component.exports